import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ProductAlchemist from './pages/ProductAlchemist';
import AboutUs from './pages/AboutUs';
import ApplicationAreas from './pages/ApplicationAreas';
import Contact from './pages/Contact';
import { trackView } from './supabase/supabase';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackView(`view_page_${pathname.replace('/', '') || 'home'}`);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-stone-50 font-sans selection:bg-emerald-200 selection:text-emerald-900">
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/alchemist" element={<ProductAlchemist />} />
            <Route path="/anwendungen" element={<ApplicationAreas />} />
            <Route path="/ueber-uns" element={<AboutUs />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;